import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";

const InternshipApplicationPosition = () => {
  const user = useSelectAccess("Industry User");
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    server
      .get("/internship/orginternshipapplications", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <h3 className="my-4 text-center">Job Application</h3>
      <div className="container" style={{ overflowX: "scroll" }}>
        <table class="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Company Name</th>
              <th scope="col">Position</th>
              <th scope="col">Description</th>
              <th scope="col">Job Mode</th>
              <th scope="col">Availability</th>
              <th scope="col">Location</th>
              <th scope="col">Resume</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.company_name}</td>

                    <td>{item.position}</td>
                    <td>{item.internship_description}</td>
                    <td>{item.internship_mode}</td>
                    <td>{item.availability}</td>
                    <td>{item.location}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default InternshipApplicationPosition;
